import APMStyles from '../styles';

/* for use with react-native-paper components only */

const textInput = {
  colors: {
    placeholder: 'white',
    primary: APMStyles.colors.accent2,
  },
};

const avatar = {
  colors: {
    primary: APMStyles.colors.accent1,
    background: APMStyles.colors.accent1,
  },
};

const Theme = {
  textInput,
  avatar,
};

export default Theme;
